import { post } from '../../shared/api/http';

/** Chamadas de autenticação que não dependem de sessão (login fica em shared/session). */
export const authApi = {
  forgotPassword: (email: string): Promise<{ ok: true }> => post('/auth/forgot-password', { email }),
  resetPassword: (token: string, password: string): Promise<{ ok: true }> => post('/auth/reset-password', { token, password }),
  changePassword: (currentPassword: string, newPassword: string): Promise<{ ok: true }> =>
    post('/auth/change-password', { currentPassword, newPassword }),
};
